import { formatINR, formatDate } from "@/lib/format";

function waNumber(mobile) {
  const digits = String(mobile || "").replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `91${digits.slice(1)}`;
  return digits;
}

export function txnMessage(customer, t) {
  const verb = t.type === "credit" ? "credited" : "debited";
  return [
    `Hi ${customer?.name || "Customer"},`,
    `Your ThankF account has been ${verb} with ${formatINR(t.amount)} on ${formatDate(t.created_at)}.`,
    t.note ? `Note: ${t.note}` : null,
    `Balance after this transaction: ${formatINR(t.balance_after)}`,
    "- ThankF",
  ]
    .filter(Boolean)
    .join("\n");
}

export function shareTxnOnWhatsApp(customer, t) {
  const url = `https://wa.me/${waNumber(customer?.mobile)}?text=${encodeURIComponent(txnMessage(customer, t))}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
